import React, { useState } from 'react'
import { RiSearch2Line } from 'react-icons/ri'

export default function SearchBar({placeholder, onSearch, value: controlledValue}) {
  const [internalValue, setInternalValue] = useState("");
  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (!isControlled) {
      setInternalValue(newValue);
    }
    if (onSearch) {
      onSearch(newValue);
    }
  };

  return (
    <div className="input-group mb-3 search">
      <span className="input-group-text bg-primary1 px-4">
        <RiSearch2Line size={20} color={"#fff"} />
      </span>
      <input
        type="text"
        className="form-control bg-gary3 border-0 p"
        style={{padding:'10px'}}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
    </div>
  )
}
